<template>
      <aside class="sidebar fixed-top  ">
        <div id="leftside-navigation" class="nano">
          <ul class="nano-content">
            <li>
              <router-link to="/agents/panel/dashboard" class="title">
                <span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span>
                <span class="title ms-1"><h6>نام کاربر </h6></span>
                <span class="title ms-1 text-danger "><h6>{{ username }}</h6> </span>
              </router-link>
            </li>
            <li>
              <router-link to="/agents/panel/dashboard" class="title">
                <span class="icon"><i class="fa fa-solar-panel" aria-hidden="true"></i></span>
                <span class="title">بسته های تخفیف </span>
              </router-link>
            </li>
            <li>
              <router-link to="/agents/panel/discount" class="title">
                <span class="icon"><i class="fa fa-box-open" aria-hidden="true"></i></span>
                <span class="title">لیست بسته های خریداری شده </span>
              </router-link>
              <router-link to="/agents/panel/transaction" class="title">
                <span class="icon"><i class="fas fa-cash-register" aria-hidden="true"></i></span>
                <span class="title">لیست تراکنش ها </span>
              </router-link>
            </li>
            <li>
              <a href="#" @click="logout"><i class="fa fa-sign-out-alt"></i>خروج</a>
            </li>
          </ul>
        </div>
      </aside>
</template>

<script setup>
const subMenuLinks = document.querySelectorAll("#leftside-navigation .sub-menu > a");
const subMenuUl = document.querySelectorAll("#leftside-navigation ul ul");
let result = JSON.parse(localStorage.getItem('users'));
let username = result.name_f

function toggleActiveClass(element) {
  if (element.classList.contains('active')) {
    element.classList.remove('active');
  } else {
    element.className = '';
    element.classList.add('active');
  }
}

function subMenuLinke(id) {
  const subMenus = document.querySelectorAll('.sub-menu');
  const targetSubMenu = document.getElementById('sub_menu_' + id);

  subMenus.forEach(subMenu => {
    subMenu.classList.remove('active');
  });

  if (targetSubMenu) {
    toggleActiveClass(targetSubMenu);
  }

}

function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}


function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('users')
  localStorage.clear();
  window.location.replace('/agents/login/');

}
</script>

